import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=2d6fda12"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RegisterButton: require('/opt/build/repo/components/register/Button.vue').default,SectionHeader: require('/opt/build/repo/components/section/Header.vue').default})
